(() => {
  if (window.__hzPredictiveSearchLoaded) return;
  window.__hzPredictiveSearchLoaded = true;

  const debounce = (fn, wait = 200) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  const fetchResults = async (q) => {
    const res = await fetch(
      `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`,
      { headers: { Accept: 'application/json' } }
    );
    if (!res.ok) return [];
    const json = await res.json();
    return json?.resources?.results?.products || [];
  };

  const render = (form, q, items) => {
    const dropdown = form.querySelector('[data-hz-search-dropdown]');
    const inner = dropdown.querySelector('.hz-search__dropdown-inner');

    if (!items.length) {
      inner.innerHTML = `
        <div class="hz-search__footer">
          <a href="/search?q=${encodeURIComponent(q)}">Search for “${q}”</a>
        </div>`;
      dropdown.hidden = false;
      return;
    }

    inner.innerHTML = items.map(p => `
      <a class="hz-search__item" href="${p.url}">
        ${p.featured_image?.url ? `<img class="hz-search__thumb" src="${p.featured_image.url}&width=80">` : ''}
        <span class="hz-search__title">${p.title}</span>
      </a>
    `).join('') + `
      <div class="hz-search__footer">
        <a href="/search?q=${encodeURIComponent(q)}">View all results</a>
      </div>`;

    dropdown.hidden = false;
  };

  document.addEventListener('input', debounce(async (e) => {
    const input = e.target.closest('[data-hz-search-input]');
    if (!input) return;

    const form = input.closest('[data-hz-search]');
    const q = input.value.trim();

    if (q.length < 2) {
      form.querySelector('[data-hz-search-dropdown]').hidden = true;
      return;
    }

    const items = await fetchResults(q);
    render(form, q, items);
  }, 180));

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-hz-search]')) {
      document.querySelectorAll('[data-hz-search-dropdown]').forEach(d => d.hidden = true);
    }
  });
})();
